import gql from "graphql-tag";

export const MY_HR_GET_PAY_OFFICES_ADMIN_LIST = gql`
  query payOfficesAdminList(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
    $payOffices: [String]
  ) {
    payOfficesAdminList(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
      payOffices: $payOffices
    ) {
      availableList {
        _id
        code
        name
      }
      selectedList {
        _id
        code
        name
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;
